require('./views');
require('./bootstrap');

import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VueTelInput from 'vue-tel-input'
import vuetify from './plugins/vuetify'

import './assets/sass/app.scss';

Vue.config.productionTip = false

Vue.use(VueTelInput, {
  autoFormat: true,
  defaultCountry: 'KE',
  onlyCountries: ['KE'],
  mode: 'international',
  dropdownOptions: {
    width: '320px',
    required: true,
    showDialCodeInList: false
  },
  inputOptions: {
    name: 'contact_person.phone',
    placeholder: 'Contact person\'s number'
  }
})

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
